import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  Label,
  CardSubtitle,
  Container,
  Spinner,
} from "reactstrap";

import {
  AvForm,
  AvField,
} from "availity-reactstrap-validation";
// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//Import Breadcrumb

import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import showNotification from "../../../../helpers/show_notification";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { convertToLowestUnit, formatUnitsForReport, GetUpdatedDelivered,  } from "../../../../helpers/units";
import preloader from "../../../../helpers/preloader";
import EnterQuantityModal from "../../../../components/EnterQuantityModal";
const animatedComponents = makeAnimated();

const FinishedProductAddOrder = (props) => {
  const role = localStorage.getItem("role")
  const storeName = localStorage.getItem("store_name")
  const refForForm = useRef(null);
  const refSelectProduct = useRef(null);
  useEffect(() => {
    loadAllProducts();
  }, []);
 
  const [remarks, setRemarks] = useState();
  const [allProducts, setAllProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState();

  const loadAllProducts = async () => {
    let url ;
    let payload = {};
    if(role==="Central Kitchen Manager"){
      // url = process.env.REACT_APP_BASEURL + "storeproductinventories/get_by_store_id"; 
      // payload.store_id=store_id
      url = process.env.REACT_APP_BASEURL + "branchproducts/getforbranch";
      payload = {}
    }else{
      url = process.env.REACT_APP_BASEURL + "branchproducts/getforbranch";
      payload = {}
    }
    preloader(true);
    let response = await postSubmitForm(url, payload);
    if (response.status === 1) {
      preloader(false);
      // const itemsLable = response.data.map(product => ({
      //   ...product.product_details,
      //   label: `${product.product_details?.category}-${product.product_details?.sub_category} -${product.product_details?.name}(${product.product_details?.brand})`,
      //   value: product._id
      // }));
      // {role === "Central Kitchen Manager" ? setAllProducts(itemsLable) : setAllProducts(response.data)}
      setAllProducts(response.data)
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };

  const [productsForOrder, setProductsForOrder] = useState([]);
  const [isUrgent, setIsUrgent] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)
  const handleValidSubmit = async (e, v) => {
    try {
      setIsDisabled(true)
      const object = {
        product_details: productsForOrder,
        remarks: v.remarks,
        is_urgent: isUrgent,
      };
      let url = process.env.REACT_APP_BASEURL + "productorders/insert";
      let response = await postSubmitForm(url, object);
      if (response.status === 1) {
        setRemarks();
        setIsDisabled(false)
        setProductsForOrder([]);
        setIsUrgent(false);
        setSelectedProduct();
        loadAllProducts();
        refSelectProduct.current.select.clearValue();
        refForForm.current.reset();
        showNotification(response.message, "Success");
        refForForm.current.reset();
      } else {
        setIsDisabled(false)
        showNotification(response.message, "Error");
      }
    } catch (error) {
      setIsDisabled(false)
      showNotification(error.message, "Error");
    }
  };
  function deleteFormatter(cell, row, rowIndex, extraData) {
    return (
      <>
        <span className="text-danger">
          <i
            className="bx bxs-trash font-size-15"
            title="Click to Delete"
            style={{ cursor: "pointer" }}
            onClick={() => {
              let arr = extraData.filter(
                (product) => product.product_id !== row.product_id
              );

              setProductsForOrder(arr);
            }}
          ></i>
        </span>
      </>
    );
  }
  const columns = [
    {
      dataField: "section",
      text: props.t("Section"),
    },
    {
      dataField: "category",
      text: props.t("Category"),
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      sort: true,
    },
    {
      text: props.t("Available"),
      dataField: "available",
      sort: false,
      editable: false,
      formatter: (cell, row) => {
        return formatUnitsForReport(row.available,row.unit_levels)             
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },
    {
      text: props.t("Quantity"),
      dataField: "arrangement_quantity",
      sort: false,
      editable: false,
      formatter: (cell, row) => {
        return formatUnitsForReport(row.arrangement_quantity)             
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },
    // {
    //   text: props.t("Converted Quantity"),
    //   dataField: "quantity",
    //   sort: false,
    //   editable: false,
    //   formatter: (cell, row) => {
    //     return formatUnitsForReport(row.quantity)             
    //   },
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "15%" };
    //   },
    //   footer: false,
    // },
    {
      text: props.t("Remove"),
      formatter: deleteFormatter,
      formatExtraData: productsForOrder,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];
  const [selectedRowsUnit, setSelectedRowsUnit] = useState([]);
  const [selectUnitModal, setSelectUnitModal] = useState(false);

  function handleCloseModal() {
    setSelectUnitModal(false);
    setSelectedRowsUnit([])
  }

  // const handleAddQuantity = async (quantity) => {
  //   let maxLimit = convertToLowestUnit(selectedProduct.unit_levels,[{unit:selectedProduct.unit_for_max_order,value:selectedProduct.max_order_limit}]);
  //   let totalEntered =   convertToLowestUnit(selectedProduct.unit_levels,quantity)
  //   if(totalEntered>maxLimit){
  //     showNotification(`can not add more than <strong>${selectedProduct.max_order_limit+" "+selectedProduct.unit_for_max_order} </strong>`,"Warning")
  //     return
  //   }
  //   let convertedQuantity = GetUpdatedDelivered(quantity,selectedProduct.unit_levels,)
  //   var new_array_items = JSON.parse(JSON.stringify(productsForOrder));
  //   const existing_item = new_array_items.filter(function (product) {
  //     return product.product_id === selectedProduct.product_id;
  //   });

  //   if (existing_item.length > 0) {
  //     showNotification(
  //       props.t("This product is already added."),
  //       props.t("Error")
  //     );
  //   } else if (selectedProduct) {
  //     let product_to_add = {};
  //     product_to_add.product_id = selectedProduct?.product_id;
  //     product_to_add.name = selectedProduct.name;
  //     product_to_add.category = selectedProduct.category;
  //     product_to_add.section = selectedProduct.section;
  //     product_to_add.brand = selectedProduct.brand;
  //     product_to_add.available = selectedProduct.available.map(({ unit, value }) => ({ unit, value: parseFloat(value) })) || null;
  //     product_to_add.quantity = convertedQuantity.map(({ unit, value }) => ({ unit, value: parseFloat(value) })) || null;
  //     product_to_add.unit_levels = selectedProduct.unit_levels.map(({unit,value})=>({unit,value}));
  //     product_to_add.expiry_date = selectedProduct.expiry_date;
  //     product_to_add.unit_for_max_order = selectedProduct.unit_for_max_order;
  //     if(selectedProduct.max_order_limit>0){
  //       product_to_add.max_order_limit = selectedProduct.max_order_limit;
  //     }
  //     product_to_add.cost_price = selectedProduct.cost_price;
  //     product_to_add.selling_price = selectedProduct.selling_price;
  //     setProductsForOrder([...productsForOrder, product_to_add]);
  //     setSelectUnitModal(false);
  //     setSelectedProduct();
  //     setSelectedRowsUnit([]);
  //     refSelectProduct.current.select.clearValue();
  //   } else {
  //     showNotification(props.t("Select a product batch first."), props.t("Error"));
  //   }
  // };

  function handleAddQuantity(e,v) {
    e.preventDefault()
    let arrangement_quantity = [{unit:selectedProduct.unit_for_max_order, value:Number(v.arrangement_quantity)}]
    // console.log(arrangement_quantity,"ar");
          let maxLimit = convertToLowestUnit(selectedProduct.unit_levels,[{unit:selectedProduct.unit_for_max_order,value:selectedProduct.max_order_limit}]);
    let totalEntered =   convertToLowestUnit(selectedProduct.unit_levels,arrangement_quantity)
    if(totalEntered>maxLimit){
      showNotification(`can not add more than <strong>${selectedProduct.max_order_limit+" "+selectedProduct.unit_for_max_order} </strong>`,"Warning")
      return
    }
    let convertedQuantity = GetUpdatedDelivered(arrangement_quantity,selectedProduct.unit_levels,)
    var new_array_items = JSON.parse(JSON.stringify(productsForOrder));
    const existing_item = new_array_items.filter(function (product) {
      return product.product_id === selectedProduct.product_id;
    });
    if (existing_item.length > 0) {
          showNotification(
            props.t("This product is already added."),
            props.t("Error")
          );
        } else if (selectedProduct) {
          let product_to_add = {};
          product_to_add.product_id = selectedProduct?.product_id;
          product_to_add.name = selectedProduct.name;
          product_to_add.category = selectedProduct.category;
          product_to_add.section = selectedProduct.section;
          product_to_add.brand = selectedProduct.brand;
          product_to_add.arrangement_quantity = arrangement_quantity;
          product_to_add.available = selectedProduct.available.map(({ unit, value }) => ({ unit, value: parseFloat(value) })) || null;
          product_to_add.quantity = convertedQuantity.map(({ unit, value }) => ({ unit, value: parseFloat(value) })) || null;
          product_to_add.initial_order_quantity = convertedQuantity.map(({ unit, value }) => ({ unit, value: parseFloat(value) })) || null;
          product_to_add.unit_levels = selectedProduct.unit_levels.map(({unit,value})=>({unit,value}));
          product_to_add.expiry_date = selectedProduct.expiry_date;
          product_to_add.unit_for_max_order = selectedProduct.unit_for_max_order;
          if(selectedProduct.max_order_limit>0){
            product_to_add.max_order_limit = selectedProduct.max_order_limit;
          }
          product_to_add.cost_price = selectedProduct.cost_price;
          product_to_add.selling_price = selectedProduct.selling_price;
          setProductsForOrder([...productsForOrder, product_to_add]);
          setSelectUnitModal(false);
          setSelectedProduct();
          setSelectedRowsUnit([]);
          refSelectProduct.current.select.clearValue();
        } else {
          showNotification(props.t("Select a product batch first."), props.t("Error"));
        }
      };
  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Products")}
            title={props.t("Orders")}
            breadcrumbItem1={props.t("Products")}
            breadcrumbItem2={props.t("Add Order")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm
                    // onValidSubmit={()=>setSelectUnitModal(!selectUnitModal)}
                    onValidSubmit={handleAddQuantity}
                    ref={refForForm}
                  >
                    <CardTitle>{props.t("Add New Order")}</CardTitle>
                    <CardSubtitle className="mb-3">
                      {props.t(
                        "Enter the following details to place order for finished products"
                      )}
                    </CardSubtitle>
                    <Row>
                      <Col lg={3} md={3}>
                        <Label>{props.t("Product")}</Label>
                        <Select
                          ref={refSelectProduct}
                          value={selectedProduct}
                          onChange={(selected) => {
                            setSelectedProduct(selected);
                          }}
                          options={allProducts}
                          classNamePrefix="select2-selection"
                          components={animatedComponents}
                          required
                        />
                      </Col>
                      {selectedProduct && (
            <>
             <Col lg={3} md={4} >
                <br />
                <p><Label>Central Kitchen Avl.</Label> -&nbsp;
                {formatUnitsForReport(selectedProduct.central_kitchen_available,selectedProduct?.unit_levels)}
                 <hr style={{marginBottom:"5px",marginTop:"-5px"}} />
                <Label>{storeName} Avl. -&nbsp; </Label> 
                {formatUnitsForReport(selectedProduct.available,selectedProduct?.unit_levels)}
                  </p>
              </Col>
              {/* <Col lg={2}>
                <br />
                <Label>Available </Label>
                <br />
                <Label>
                  {formatUnitsForReport(selectedProduct.available,selectedProduct?.unit_levels)}
                </Label>
              </Col> */}
              <Col lg={2} md={2}>
                <br />
                <Label>Threshold Quantity</Label>
                <br />
                <Label>
                  {selectedProduct.threshold +
                    " " +
                    selectedProduct.unit_for_threshold}
                </Label>
              </Col>
              <Col lg={2} md={2}>
                              <Label>
                                {props.t("Qty.")} in {`${selectedProduct.unit_for_max_order}`}
                              </Label>

                              <AvField
                                name="arrangement_quantity"
                                placeholder={props.t("Enter Quantity")}
                                type="number"
                                min="0"
                                step="1"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Quantity cannot be empty.",
                                  },
                                  pattern: {
                                    value: "^[0-9]+$",
                                    errorMessage: props.t(
                                      "Only numbers are allowed."
                                    ),
                                  },
                                  max: {
                                    value:selectedProduct && selectedProduct.max_order_limit,
                                    errorMessage: selectedProduct &&
                                      props.t("Cannot enter more than ") +
                                      selectedProduct.max_order_limit +" " +selectedProduct.unit_for_max_order +".",
                                  },
                                  min: {
                                    value:1,
                                    errorMessage: props.t("Minimum 1 is required"),
                                  },
                                }}
                              />
                            </Col>
            </>
          )}

                  <Col lg={1} md={1} className="mb-4">
                        <Label>&nbsp;</Label>
                        <br />
                        <Button
                          type="submit"
                          color="primary"
                          className="btn btn-info waves-effect waves-light btn-sm"
                        >
                          <i class="bx bx-add-to-queue"></i> {props.t("Add")}
                        </Button>
                      </Col>
                    </Row>
                    {/* <Button type="submit">Submit</Button> */}
                  </AvForm>
                  <hr />
                  {productsForOrder && productsForOrder.length > 0 && (
                    <>
                      <BootstrapTable
                        bootstrap4
                        keyField="_id"
                        data={productsForOrder && productsForOrder}
                        columns={columns}
                        noDataIndication="No data to display."
                        striped
                        hover
                        condensed
                      />
                      <AvForm onValidSubmit={handleValidSubmit}>
                        <Row>
                          <Col lg={6}>
                            <AvField
                              name="remarks"
                              value={remarks}
                              onChange={(e) => {
                                setRemarks(e.target.value);
                              }}
                              label={props.t("Remarks")}
                              placeholder={props.t("Enter Remarks")}
                              type="textarea"
                            />
                          </Col>
                          <Col lg={12}>
                            <div class="form-check">
                              <input
                                type="checkbox"
                                name="is_urgent"
                                id="isUrgentCheckbox"
                                className="is-untouched is-pristine av-valid form-check-input"
                                checked={isUrgent}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setIsUrgent(true);
                                  } else {
                                    setIsUrgent(false);
                                  }
                                }}
                              />
                              <label for="isUrgentCheckbox">
                                {props.t("This is an urgent order.")}
                              </label>
                            </div>
                          </Col>
                          <Col lg={12}>
                            <hr />
                            <FormGroup className="mb-0 text-left">
                              <div>
                                <Button
                                  type="submit"
                                  color="primary"
                                  disabled={isDisabled}
                                  style={{width:"150px"}}
                                  className="mr-1"
                                >
                                {isDisabled ? <Spinner size="sm" /> : props.t("Place Order")} 
                                </Button>
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                      </AvForm>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {/* Add Quantity modal  */}
        <EnterQuantityModal
            isOpen={selectUnitModal}
            toggle={handleCloseModal}
            onSubmit={handleAddQuantity}
            item={selectedProduct}
            checkLimitFor={"order"}
            // selectedBatch={selectedBatch}
          />


      </div>
    </React.Fragment>
  );
};
export default withRouter(connect(null, {})(withNamespaces()(FinishedProductAddOrder)));
